/* eslint-disable */
import Page from 'components/Layout/Page'
import useToast from 'hooks/useToast'
import { useEffect, useState } from 'react'
import QuotationTable from 'views/Info/components/InfoTables/QuotationTable'
import { getChangeForPeriod } from 'utils/getChangeForPeriod'
import { getMarket } from 'service/service'
import { PoolData } from 'state/info/types'
import { getPercentChange } from 'views/Info/utils/infoDataHelpers'
import useDebounce from 'hooks/useDebounce'
import { useTranslation } from '@noahswap/localization'
import { useMatchBreakpoints } from '@noahswap/uikit'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import chainUtils from 'service/chainUtils'
import { useRouter } from 'next/router'
import QuotationMobile from './components/QuotationMobile'

export default function Quotation() {
  const [searchValue, setSearchValue] = useState('')
  const [tableType, setTableType] = useState(0)
  const [changeTableType, setChangeTableType] = useState(0)
  const debouncedQuery = useDebounce(searchValue, 200)
  const [fetchState, setFetchState] = useState<PoolData[]>([])
  const [defaultFetchState, setDefaultFetchState] = useState<PoolData[]>([])
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const { isDesktop } = useMatchBreakpoints()
  const isMobile = isDesktop === false
  // const { chainId } = useActiveWeb3React()
  const router = useRouter()
  // const parsedQueryChainId = Number(router.query.chainId)
  // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId'))

  useEffect(() => {
    const { baseURL, chainid } = chainUtils()
    setLoading(true)
    // console.log(tableType, 'tableType')
    // console.log(debouncedQuery, 'debouncedQuery')
    // if (debouncedQuery) {
    //   setTableType(0)
    // }
    // if (tableType) {
    //   setChangeTableType(tableType)
    // }
    const fetch = async () => {
      const params = {
        limit: 100,
        type: 2,
        orderColumn: 'usd_balance',
        isAsc: true,
        symbol: debouncedQuery,
        quoteCoin: debouncedQuery ? 0 : tableType,
      }
      const { code, data } = await getMarket(params, { baseURL, chainid })

      if (!code) {
        const dataFormat = data?.map((current) => {
          const yesterdayPrice = getPercentChange(current?.price, current?.yesterday_price)
          const liquidityUSD = current ? current.usd_balance2 : 0

          const liquidityUSDChange = getPercentChange(current?.usd_balance2 || 0, current?.usd_balance2 || 0)

          const liquidityToken0 = current ? current.count0 : 0
          const liquidityToken1 = current ? current.count1 : 0

          return {
            reserve0: current.contract0,
            reserve1: current.contract1,
            address: current.pair_id.toString(),
            reserveUSD: liquidityUSD.toString(),
            token0: {
              address: current.contract0,
              name: current.name0,
              symbol: current.symbol0,
            },
            token1: {
              address: current.contract1,
              name: current.name1,
              symbol: current.symbol1,
            },
            token0Price: (current.count0 / current.count1).toString() || 0,
            token1Price: (current.count1 / current.count0).toString() || 0,
            volumeUSD: current.volume_usd_24h,
            volumeUSDChange: 0,
            totalFees24h: current.fee_usd_24h,
            // totalFees7d,
            lpFees24h: 0,
            // lpFees7d,
            lpApr7d: 0,
            liquidityUSD,
            liquidityUSDChange,
            liquidityToken0,
            liquidityToken1,
            price: current.price,
            priceUsd: current.priceUsd,
            priceChange: yesterdayPrice,
            swapCount: current.swap_count_24h,
            usdBalance2: current.usd_balance2,
            direction: current.price_direction,
            recommend: current.recommend,
            newPair: current.newPair,
          }
        })
        setDefaultFetchState(dataFormat)
        setTimeout(() => {
          setLoading(false)
        }, 100)
      } else {
        setLoading(false)
        setDefaultFetchState([])
      }
    }
    const timer = setInterval(() => {
      fetch()
    }, 10000)
    fetch()
    return () => clearInterval(timer)
  }, [tableType, debouncedQuery])

  // useEffect(() => {
  //   let dataFormat = defaultFetchState || []
  //   if (!debouncedQuery) {
  //     dataFormat = defaultFetchState
  //   } else {
  //     dataFormat = dataFormat.filter((v) => {
  //       return (
  //         v?.token0?.symbol.toUpperCase().indexOf(debouncedQuery.toUpperCase()) > -1 ||
  //         v?.token1?.symbol.toUpperCase().indexOf(debouncedQuery.toUpperCase()) > -1
  //       )
  //     })
  //   }
  //   setFetchState(dataFormat)
  // }, [debouncedQuery, defaultFetchState])

  return (
    <Page>
      {!isMobile ? (
        <QuotationTable
          poolDatas={defaultFetchState}
          loading={loading}
          title={t('noah62')}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          tableType={tableType}
          setTableType={setTableType}
        />
      ) : (
        <QuotationMobile
          poolDatas={defaultFetchState}
          loading={loading}
          title={t('noah62')}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          tableType={tableType}
          setTableType={setTableType}
        />
      )}
    </Page>
  )
}
